import { render, staticRenderFns } from "./BROSADIdCheck.vue?vue&type=template&id=dc93a57a&scoped=true"
import script from "./BROSADIdCheck.vue?vue&type=script&lang=js"
export * from "./BROSADIdCheck.vue?vue&type=script&lang=js"
import style0 from "./BROSADIdCheck.vue?vue&type=style&index=0&id=dc93a57a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc93a57a",
  null
  
)

export default component.exports